import { EmptyState, EmptyStateSize } from '@pdcplan/shared/components';
import React from 'react';
import { colors } from '@pdcfrontendui/components';
import { currentLanguage } from '../currentLanguage';
import { useFormatter } from '../hooks/useLang';

function NoChangesShiftsImage() {
  return (
    <svg
      width="221px"
      height="203px"
      viewBox="0 0 221 203"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Empty state/Illustration/NoChangesToShow"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-0, 0)">
          <rect x="11.0213608" y="0" width="203" height="203"></rect>
          <path
            d="M165.232813,56.2670374 C183.922128,66.3768575 206.985537,71.24906 210.69689,82.8205408 C214.408244,94.5138267 198.767541,113.150001 193.067963,131.42076 C187.368384,149.691519 191.742479,167.596863 184.452321,177.341268 C177.162163,187.207478 158.207752,189.034554 142.434501,187.207478 C126.661249,185.502207 113.93661,180.26459 95.114747,181.117225 C76.4254325,181.848056 51.6388949,188.669139 34.2750637,182.700691 C17.0437809,176.732243 7.10265613,157.852459 10.4163644,140.79975 C13.7300726,123.868846 30.2986138,108.521409 38.7817069,89.3980141 C47.3973483,70.2746195 48.06009,47.2534629 59.8568913,34.2203213 C71.6536927,21.1871798 94.717102,18.0202482 113.406417,24.2323063 C132.095731,30.4443644 146.410951,46.0354123 165.232813,56.2670374 Z"
            id="Path"
            fill={colors.colorPrimaryLightest}
            fillRule="nonzero"
            transform="translate(110.5214, 104.5) rotate(-7.3085) translate(-110.5214, -104.5)"
          ></path>
          <polygon
            fill={colors.colorPrimaryUltraLightest}
            points="112.042292 53.0779812 87.4099238 77.9634452 58.9201545 92.0519852 74.9022934 120.401509 77.325243 152.384349 106.419844 146.755648 143.980431 155.665467 148.844333 120.401509 164.694899 92.0519852 133.696336 77.9634452"
          ></polygon>
          <ellipse
            fill={colors.colorPrimaryDark}
            cx="112.042292"
            cy="122.95469"
            rx="5.6224479"
            ry="5.73178516"
          ></ellipse>
          <path
            d="M170.64064,66.2490861 L170.64064,62.1175977 L178.001363,53.4993901 C179.209591,52.0939118 180.103453,51.0977212 180.682948,50.5030957 C180.079213,50.5417078 179.283827,50.564875 178.297549,50.5803198 L171.362547,50.6189319 L171.362547,46.2248816 L187.599771,46.2248816 L187.599771,49.977972 L180.091333,58.8046846 L177.446866,61.7237549 C178.889165,61.6388084 179.783026,61.5924739 180.128451,61.5924739 L188.173206,61.5924739 L188.173206,66.2490861 L170.64064,66.2490861 Z"
            fill={colors.colorPrimaryBaseDark}
            fillRule="nonzero"
          ></path>
          <path
            d="M148.844333,42.0045313 L148.844333,35.4490419 L159.870358,21.7744134 C161.680228,19.5443216 163.019192,17.9636522 163.887249,17.0201518 C162.982881,17.0814181 161.79143,17.1181779 160.314031,17.1426844 L149.925716,17.2039506 L149.925716,10.2318506 L174.248331,10.2318506 L174.248331,16.1869308 L163.001036,30.192397 L159.039746,34.824126 C161.200244,34.6893403 162.539207,34.6158208 163.056637,34.6158208 L175.10731,34.6158208 L175.10731,42.0045313 L148.844333,42.0045313 Z"
            fill={colors.colorPrimaryBaseDark}
            fillRule="nonzero"
          ></path>
          <path
            d="M110.945726,51.2109761 C111.200915,51.1916194 111.463489,51.2696142 111.67296,51.4495484 L131.886772,74.9640177 C133.00417,76.2648431 134.410227,77.2864029 135.99268,77.9471344 L164.467899,89.8365665 C164.722721,89.9429639 164.910293,90.1425756 165.00756,90.3792935 C165.104827,90.6160113 165.111789,90.8898353 165.005392,91.1446573 L148.888214,117.635506 C147.99635,119.100191 147.459285,120.75311 147.319897,122.46229 L144.811701,153.217869 C144.789255,153.493097 144.657376,153.733172 144.462301,153.898828 C144.267227,154.064485 144.008956,154.155723 143.733727,154.133277 L113.558951,146.991052 C111.890351,146.595453 110.15237,146.595453 108.48377,146.991052 L78.4584017,154.109613 C78.1897076,154.173316 77.92063,154.122079 77.7028,153.987743 C77.48497,153.853406 77.3183877,153.63597 77.2546844,153.367276 L74.7228251,122.46229 C74.5834371,120.75311 74.0463713,119.100191 73.1545078,117.635506 L57.106005,91.2794396 C56.9623886,91.0435818 56.9279685,90.7718405 56.9884171,90.5231595 C57.0488656,90.2744786 57.2041828,90.048858 57.4400406,89.9052416 L86.0500414,77.9471344 C87.6324948,77.2864029 89.0385513,76.2648431 90.1559492,74.9640177 L110.262798,51.5565122 C110.442732,51.3470408 110.690537,51.2303327 110.945726,51.2109761 Z"
            stroke={colors.colorPrimaryDark}
            strokeWidth="10"
          ></path>
          <g
            transform="translate(81.9212, 99.0874)"
            fill={colors.colorPrimaryDark}
            fillRule="nonzero"
          >
            <path d="M2.20029785,0 C3.51078816,3.72756941 6.77472921,6.22061852 10.4346699,6.22061852 C14.0928069,6.22061852 17.3543799,3.73204587 18.666982,0.00816330909 L20.8666492,0.783506708 C19.2357164,5.41050103 15.1171817,8.55293355 10.4346699,8.55293355 C5.7495376,8.55293355 1.62828366,5.40505549 0,0.773552066 L2.20029785,0 Z"></path>
            <path d="M41.2002978,0 C42.5107882,3.72756941 45.7747292,6.22061852 49.4346699,6.22061852 C53.0928069,6.22061852 56.3543799,3.73204587 57.666982,0.00816330909 L59.8666492,0.783506708 C58.2357164,5.41050103 54.1171817,8.55293355 49.4346699,8.55293355 C44.7495376,8.55293355 40.6282837,5.40505549 39,0.773552066 L41.2002978,0 Z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default function NoChangesShifts({
  className,
  from,
  to,
}: {
  className?: string;
  from: Date;
  to: Date;
}) {
  const formatter = useFormatter();
  return (
    <EmptyState
      className={className}
      image={NoChangesShiftsImage}
      heading={currentLanguage.NoChanges}
      description={currentLanguage.NoChangesHaveBeenMade_2(
        formatter.dayDescription(from, false),
        formatter.dayDescription(to, true)
      )}
      size={EmptyStateSize.Large}
    />
  );
}
